module.exports = __webpack_public_path__ + "static/media/personal_icon.6b6eeb5d.svg";